require('./RARiskInput.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const RAInput = require('../../commons/RAInput/RAInput');
const RAOneLineSymbolAmount = require('../../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @constants
const { EURO_SYMBOL } = require('constants/index');

class RARiskInput extends React.Component {
    constructor(props) {
        super(props);
        this.updateResultValue = this.updateResultValue.bind(this);
    }

    updateResultValue(value) {
        this.props.updateVolatilityInputValue(value);
    }

    buildInputComponent() {
        const { disabled } = this.props;
        return (
            <div className="ra-risk-input__container__label2__input">
                <RAInput
                    amount={this.props.amount}
                    onhandleChange={this.updateResultValue}
                    min={0}
                    max={5000000}
                    showBlurZero={this.props.showBlurZero}
                    disabled={disabled}
                />
            </div>
        );
    }

    render() {
        const { amount, sliderValue, disabled } = this.props;
        const injectedCalculatedValue = (amount * sliderValue) / 100;
        const raInputComponent = this.buildInputComponent();
        const raAmountComponent = (
            <RAOneLineSymbolAmount
                className="ra-risk-input__amount"
                amountObject={{
                    amount: injectedCalculatedValue,
                    currency: EURO_SYMBOL,
                }}
                trimDecimals={true}
            />
        );
        const classLabel1 = classnames('ra-risk-input__container__label1', {
            'ra-risk-input__container__label1--is-disabled': !!disabled,
        });
        const classLabel2 = classnames('ra-risk-input__container__label2', {
            'ra-risk-input__container__label2--is-disabled': !!disabled,
        });
        return (
            <div className="ra-risk-input">
                <div className="ra-risk-input__container">
                    <div className={classLabel1}>
                        <FormattedTextWithComponents
                            value="volatilityInput-inputLabel"
                            injectedComponents={[raInputComponent]}
                        />
                    </div>
                    <div className={classLabel2}>
                        <FormattedTextWithComponents
                            value="volatilityInput-amountLabel"
                            injectedComponents={[raAmountComponent]}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RARiskInput.propTypes = {
    amount: PropTypes.number,
    disabled: PropTypes.bool,
    showBlurZero: PropTypes.bool,
    sliderValue: PropTypes.number,
    updateVolatilityInputValue: PropTypes.func,
};

module.exports = RARiskInput;
